/**
 * Express checkout buttons inside the slide-out cart.
 *
 * BigCommerce always renders an Apple Pay container in cart.additional_checkout_buttons,
 * but Apple Pay only functions in Safari / on Apple devices (window.ApplePaySession). On
 * other browsers it renders empty, leaving a blank cell in the compact express grid.
 *
 * The drawer's `.side-cart-actions` HTML is re-rendered from many add-to-cart paths, so
 * rather than wire every call site we observe the actions container and re-apply the rule
 * on each render. Mirrors the theme's page-load Apple Pay toggle in global.js.
 *
 * This module is VISUAL only. Analytics for these buttons (express_checkout_start) lives in
 * f/express-checkout-tracking.js, init'd from global.js.
 */
function refreshExpressCheckout() {
    const $applePay = $('.side-cart-express .ApplePayCheckout');

    if (!$applePay.length) {
        return;
    }

    if (typeof window.ApplePaySession === 'undefined') {
        $applePay.hide();
    } else {
        $applePay.show().find('.apple-pay-checkout-button').show();
    }
}

/**
 * Watch the slide-out cart's actions container (re-rendered via getContent from many
 * add-to-cart paths) and re-apply the express-checkout adjustments on every render.
 * Call once on page load. Safe to call when the container is absent.
 */
export default function initExpressCheckout() {
    const containers = document.querySelectorAll('.side-cart-actions');

    if (!containers.length || typeof window.MutationObserver === 'undefined') {
        refreshExpressCheckout();
        return;
    }

    const observer = new MutationObserver(() => refreshExpressCheckout());
    containers.forEach((el) => observer.observe(el, { childList: true }));
    refreshExpressCheckout();
}
